import { AxiosReports, AxiosReportLas } from '../config';

const OccurrenceService = {
  validateLogin: (login, token) => {
    return AxiosReportLas({
      method: 'post',
      url: `/v1/Relatorios/ValidarEmailUsuario?login=${login}`,
      headers: {
        'content-type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  },
  sendExcelByEmail: ({
    token,
    empresa,
    login,
    dataInicial,
    dataFinal,
    unidades,
    ocorrenciasEmAberto,
    ocorrenciasAuditoria,
    ocorrenciasAtrasadas,
    sistemas,
    statusOcorrencias,
  }) => {
    // if (ocorrenciasEmAberto) {
    //   return AxiosReportLas({
    //     method: 'post',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       Authorization: token ? `Bearer ${token}` : '',
    //       EmpresaId: empresa,
    //     },
    //     url: '/v1/Relatorios/Ocorrencias',
    //     data: {
    //       login,
    //       empresa,
    //       listUnidadesId: unidades,
    //       ocorrenciasEmAberto,
    //       ocorrenciasAuditoria,
    //       ocorrenciasAtrasadas,
    //       sistemas,
    //       statusOcorrencias,
    //     },
    //   });
    // }
    return AxiosReportLas({
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        EmpresaId: empresa,
      },
      url: '/v1/Relatorios/Ocorrencias',
      data: {
        login,
        empresa,
        dataInicial,
        dataFinal,
        listUnidadesId: unidades,
        ocorrenciasEmAberto,
        ocorrenciasAuditoria,
        ocorrenciasAtrasadas,
        sistemas,
        statusOcorrencias,
      },
    });
  },
  generatePDF: ({
    companyId,
    unitGroups,
    unitSubgroups,
    states,
    systems,
    units,
    showOnlyOpenOccurrences,
    showAuditOccurrence,
    showOnlyDelayedOccurrences,
    period,
    status,
    people,
    local,
    prioritization,
    occurrences,
    corrections,
    metrics,
    userId,
    token,
  }) => {
    return AxiosReports({
      method: 'post',
      responseType: 'blob',
      url: `occurrences/pdf/${companyId}`,
      data: {
        unitGroups,
        unitSubgroups,
        states,
        systems,
        units,
        showOnlyOpenOccurrences,
        showAuditOccurrence,
        showOnlyDelayedOccurrences,
        period,
        status,
        people,
        local,
        prioritization,
        occurrences,
        corrections,
        metrics,
        userId,
        token,
      },
    });
  },
};

export { OccurrenceService };
